import React from 'react';
import ReactDOM from 'react-dom';
import Homepage from '../components/homepage';
import { Provider } from 'react-redux';
import { store } from '../store';
import { ChakraProvider } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import theme from '../components/theme';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Sentry.ErrorBoundary fallback={'An error has occurred'}>
      <ChakraProvider theme={theme} CSSReset portalZIndex>
        <Provider store={store}>
          <Homepage />
        </Provider>
      </ChakraProvider>
    </Sentry.ErrorBoundary>,
    document.querySelector('#homepage')
  );
});
